<template>
  <div class="w-100 d-flex justify-content-center align-items-center gdpr">
    <div class="flex flex-column justify-content-center align-items-center border gdpr__wrapper">
      <h1 class="gdpr__title text-center">
        GDPR Opt-In
      </h1>
      <div
        class="gdpr__compliance mt-4 mb-4"
      >
        <p>
          Data Protection Laws: Any law, statute, declaration, decree, directive, legislative enactment, order, ordinance, regulation, rule or other binding restriction (as amended, consolidated or re-enacted from time to time) which relates to the protection of individuals with regards to the processing of personal data is subject to the provisions of the EU General Data Protection Regulation (GDPR) or, in the event that the United Kingdom leaves the European Union, all legislation enacted in the United Kingdom in respect of the protection of personal data.
        </p>

        <p>
          The GDPR requires that personal data is:
        </p>

        <ul>
          <li>Processed lawfully, fairly and in a transparent manner;</li>
          <li>Collected for specified, explicit and legitimate purposes and not further used in any way that is incompatible with those purposes;</li>
          <li>
            Adequate, relevant and limited to what is necessary for the purpose(s) it is used;
          </li><li>Accurate and kept up-to-date;</li>
          <li>Retained for no longer than necessary in light of the purpose(s) for which it was originally collected; and</li>
          <li>Used in a secure manner, protected against accidental loss, destruction or damage, and against unauthorised or unlawful processing.</li>
        </ul>


        <p class="font-weight-bold mb-0">
          Please confirm your understanding of the above requirements and obligations with respect to the processing of personal data by ticking this box
        </p>
      </div>

      <hr>
      <div class="checkboxAgreeGdpr mt-4">
        <div class="my-2 custom-control custom-checkbox text-center">
          <input
            type="checkbox"
            v-model="agreeGdpr"
            class="custom-control-input"
            id="agreeGdpr"
          >
          <label
            class="custom-control-label"
            for="agreeGdpr"
          >
            Agree to GDPR requirements
          </label>
        </div>
      </div>

      <div class="gdpr__buttons mt-4 ml-auto mr-auto">
        <router-link
          :to="{ name: 'logout' }"
          class="btn btn-outline-primary btn-logout d-inline-block mr-2"
        >
          Log out
        </router-link>

        <button
          class="btn btn-primary d-inline-block"
          :class="{ disabled: !agreeGdpr }"
          :disabled="!agreeGdpr"
          @click="updateGdpr"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {errorNotification, successNotification} from '@/notifications'

export default {
  data () {
    return {
      agreeGdpr: false,
    }
  },

  computed: {

  },

  methods: {
    updateGdpr () {
      // TODO!!
      this.$http.put(`/user/admin-gdpr`, this.gdpr)
          .then(this.updatedGdpr)
          .catch(this.failedGdpr)
    },

    failedGdpr () {
      this.$notify(errorNotification('Unable to update your GDPR settings at this time.'))
    },

    updatedGdpr (response) {
      if (!this.modal) {
        this.$notify(successNotification('Your GDPR settings have been updated!'))
      }

      this.$login.user.update_admin_gdpr_at = response.data.update_admin_gdpr_at
      this.$emit('compliant')
    },
  },
}
</script>

<style lang="scss">
.gdpr {
  height: 100vh !important;
  background: $header-bar-bg;
  overflow: hidden;
  &__title {
    color: $popover;
  }
  &__wrapper {
    width: 636px;
    padding: 2rem 3rem;
    border-radius: 4px;
    background: white;
    height: 636px;
    overflow: hidden;

    svg.i {
      margin-right: 4px;
    }
  }
  &__compliance {
    height: 371px;
    overflow: auto;
  }
  &__buttons {
    width: auto;
    display: table;
    .btn-logout {
      line-height: 40px;
    }
  }

  .checkboxAgreeGdpr label {
    color: $text-gray;
  }
}
</style>

